
import { Alert, AlertDescription } from '@/components/ui/alert';
import AuthCard from './AuthCard';
import AuthSuccessView from './confirmation/AuthSuccessView';
import AuthPendingView from './confirmation/AuthPendingView';
import { useAuthConfirmation } from './confirmation/useAuthConfirmation';

const ConfirmationRedirect = () => {
  const { loading, error, success, hasToken, handleCompleteAuth } = useAuthConfirmation();

  return (
    <AuthCard mode="verification">
      <div className="space-y-4">
        {error ? (
          <Alert variant="destructive">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        ) : success ? (
          <AuthSuccessView />
        ) : hasToken ? (
          <AuthPendingView 
            onAuthenticate={handleCompleteAuth}
            loading={loading}
          />
        ) : (
          <Alert>
            <AlertDescription>No authentication token found. Please check your email link and try again.</AlertDescription>
          </Alert>
        )}
      </div>
    </AuthCard>
  );
};

export default ConfirmationRedirect;
